export enum SUBSCRIPTION_STATES {
    ACTIVE = 'active',
    REDEMPTION = 'redemption',
    CANCELLED = 'cancelled',
    CHARGEBACK = 'chargeback',
    UPCOMING = 'upcoming', // client side type
    EXPIRED = 'expired', // client side type
    DISCOUNT = 'discount', // client side type
    FreeMonth = 'freeMonth', // client side type
    Paused = 'paused',
    Reminder = 'reminder',
}

export enum DISCOUNT_TYPES {
    base = 'base',
    extra = 'extra',
}
